import { render } from "./create_user.html?vue&type=template&id=ee88b040&external"
import script from "./create_user.js?vue&type=script&lang=js&external"
export * from "./create_user.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__